import { useEffect, useCallback } from 'react';

import { useSocket } from '@gogame/sockets';

import {
  EVENT_UPDATE_ACTIVITY_TYPES,
  EVENT_UPDATE_UNSAVED_CHANGES,
} from '../constants';

export const useSocketUpdateActivityTypes = (
  callbackOriginal,
  meta,
  deps = []
) => {
  const socket = useSocket();

  const callback = useCallback(
    (...props) => {
      callbackOriginal(...props);

      if (!meta.hasUnsavedChanges) {
        socket.emit(EVENT_UPDATE_UNSAVED_CHANGES, {
          year: meta.year,
          month: meta.month,
        });
      }
    },
    [meta, ...deps]
  );

  useEffect(() => {
    socket.on(EVENT_UPDATE_ACTIVITY_TYPES, callback);
    return () => {
      socket.off(EVENT_UPDATE_ACTIVITY_TYPES, callback);
    };
  }, [socket, callback]);
};
